var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.08 6c.584 0 1.085.242 1.42.645l8.101 8.873c.585.564.501 1.532-.084 2.097-.584.564-1.586.484-2.171-.08l-.084-.082-7.099-7.743c-.084-.08-.167-.08-.334 0l-7.1 7.743c-.584.646-1.503.726-2.171.162-.668-.565-.752-1.452-.167-2.097l.083-.081 8.102-8.872c.418-.323.919-.565 1.503-.565"
  })));
};
export default SvgChevronUp;